var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "health-chart-container" }, [
    _c("div", { staticClass: "chart-header" }, [
      _c("div", { staticClass: "title-section" }, [
        _c("div", {
          staticClass: "title-bar",
          style: { backgroundColor: _vm.barColor },
        }),
        _c("span", { staticClass: "chart-title" }, [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm.chartType !== "ring"
        ? _c(
            "div",
            { staticClass: "time-tabs" },
            _vm._l(_vm.tabs, function (tab) {
              return _c(
                "span",
                {
                  key: tab,
                  class: ["tab-item", { active: _vm.activeTab === tab }],
                  on: {
                    click: function ($event) {
                      return _vm.handleTabChange(tab)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(tab) + " ")]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm.viewType === "1" && _vm.dayData && _vm.chartType !== "ring"
      ? _c("div", { staticClass: "day-view-calendar" }, [
          _c("div", { staticClass: "calendar-left" }, [
            _c("div", { staticClass: "date-info" }, [
              _c("div", { staticClass: "date-number" }, [
                _vm._v(_vm._s(_vm.todayDate)),
              ]),
              _c("div", { staticClass: "date-year-month" }, [
                _vm._v(_vm._s(_vm.todayYearMonth)),
              ]),
              _c("div", { staticClass: "date-weekday" }, [
                _c("span", { staticClass: "weekday-tag" }, [_vm._v("星")]),
                _c("span", { staticClass: "weekday-tag" }, [_vm._v("期")]),
                _c("span", { staticClass: "weekday-tag" }, [
                  _vm._v(_vm._s(_vm.todayWeekday)),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "calendar-divider" }),
          _c("div", { staticClass: "calendar-right" }, [
            _c("div", { staticClass: "calendar-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c("div", { staticClass: "calendar-count" }, [
              _c("span", { staticClass: "count-text" }, [_vm._v("打卡")]),
              _c("span", { staticClass: "count-num" }, [
                _vm._v(_vm._s(_vm.dayData.count || 0) + "次"),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCharts || _vm.chartType === "ring",
            expression: "showCharts || chartType === 'ring'",
          },
        ],
        staticClass: "chart-content-wrapper",
      },
      [
        _c(
          "div",
          {
            staticClass: "chart-content",
            class: { "ring-chart": _vm.chartType === "ring" },
          },
          [
            _vm.showStats && _vm.chartType !== "ring"
              ? _c("div", { staticClass: "stats-section" }, [
                  _c(
                    "div",
                    {
                      staticClass: "stats-icon",
                      style: { backgroundColor: _vm.iconBgColor },
                    },
                    [
                      _vm._t("icon", function () {
                        return [
                          _c("i", {
                            class: _vm.iconClass,
                            style: { color: _vm.primaryColor },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "stats-value",
                      style: { color: _vm.primaryColor },
                    },
                    [_vm._v(_vm._s(_vm.statsValue))]
                  ),
                  _c("div", { staticClass: "stats-label" }, [
                    _vm._v(_vm._s(_vm.statsLabel)),
                  ]),
                ])
              : _vm._e(),
            _c("div", {
              ref: "chartRef",
              staticClass: "chart-area",
              style: { width: _vm.chartWidth, height: _vm.chartHeight },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }